// DO NOT MODIFY, this file is autogenerated by tools/build.ts
export * from 'firebase/analytics';
import { ɵzoneWrap } from '@angular/fire';
import {
  getAnalytics as _getAnalytics,
  initializeAnalytics as _initializeAnalytics,
  logEvent as _logEvent,
  setAnalyticsCollectionEnabled as _setAnalyticsCollectionEnabled,
  setCurrentScreen as _setCurrentScreen,
  settings as _settings,
  setUserId as _setUserId,
  setUserProperties as _setUserProperties
} from 'firebase/analytics';

export {
  isSupported
} from './overrides';

export const getAnalytics = ɵzoneWrap(_getAnalytics, true);
export const initializeAnalytics = ɵzoneWrap(_initializeAnalytics, true);
export const logEvent = ɵzoneWrap(_logEvent, true);
export const setAnalyticsCollectionEnabled = ɵzoneWrap(_setAnalyticsCollectionEnabled, true);
export const setCurrentScreen = ɵzoneWrap(_setCurrentScreen, true);
export const settings = ɵzoneWrap(_settings, true);
export const setUserId = ɵzoneWrap(_setUserId, true);
export const setUserProperties = ɵzoneWrap(_setUserProperties, true);
